import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { FormGroup, FormBuilder, FormArray, FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { UtilService } from '../../../../../shared/_services/util.service';
import { EmployeeService } from '../../../../../shared/_services/employee.service';
import { StatusModalComponent } from '../../../../modals/status-modal/status-modal.component';

@Component({
  selector: 'app-exchange-benefits',
  templateUrl: './exchange-benefits.component.html',
  styleUrls: ['./exchange-benefits.component.scss']
})
export class ExchangeBenefitsComponent implements OnInit {
  statusModal: BsModalRef;
  activateAction: boolean;
  isFiltered: any;
  BenefitsList: any[] = [];
  searchForm: FormGroup;
  isFilterOn: boolean = false;
  filterForm: FormGroup;
  filterLookUpDate: any;
  p: number = 0;
  size: number = 10;
  totalCount: any;
  allBenefitsSelected: boolean;
  selectedBenefits: any[] = [];
  bsModalRef: BsModalRef;
  private unsubscribe: Subject<void> = new Subject<void>();
  tableHeader: any = [
    { 'key': 'Code', 'property': 'empCode', 'direction': 'asc' },
    { 'key': 'Benefit', 'property': 'benefitName', 'direction': null },
    { 'key': 'Hotel', 'property': 'hotelName', 'direction': null },
    { 'key': 'First Name', 'property': 'firstName', 'direction': null },
    { 'key': 'Last Name', 'property': 'lastName2', 'direction': null },
    { 'key': 'Redeemed', 'property': 'exchanged', 'direction': null },
  ];
  constructor(
    private fb: FormBuilder,
    private modalService: BsModalService,
    private utilService: UtilService,
    private employeeService: EmployeeService
  ) {
    document.addEventListener('click', this.offClickHandler.bind(this));
    this.modalService.onHide
      .takeUntil(this.unsubscribe)
      .subscribe(res => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.action == "action1") {
            if (this.statusModal.content.srcObject.type == "member-edit") {
              if (this.statusModal.content.srcObject.status || this.statusModal.content.srcObject.status == 0) {
                let status = +this.statusModal.content.srcObject.status;
                // this.activateOrDeactivateEmployee(this.statusModal.content.srcObject.id, status);
              } else {
                // this.router.navigate(['/members']);
              }
            }
          }
        }
      })
  }

  offClickHandler(event: any) {
    if (!event.target.closest(".filter") && !event.target.closest(".filter")) {
      // do whatever you want here
      if (document.getElementById('ul')) {
        document.getElementById('ul').style.display = 'none';
      }
    }
  }

  dropDown(e) {
    // event.stopPropagation();
    if (document.getElementById('ul').style.display == 'block') {
      document.getElementById('ul').style.display = 'none';
    } else {
      document.getElementById('ul').style.display = 'block';
    }
  }


  sortTable(property: any) {
    this.tableHeader.forEach((header: any) => {
      if (header.property === property) {
        header.direction = header.direction && header.direction == 'asc' ? 'desc' : 'asc';
        // header.direction = !header.direction;
      }
      if (header.property !== property) {
        header.direction = null;
      }
    });
    this.pageChanged(1);
  }

  getFilterLookUpDate() {
    this.employeeService.getExchangeOfBenefitsLookupData().subscribe(res => {
      if (res.error == 0) {
        this.filterLookUpDate = res.responseObj;
        this.checkSelected(true, 'hotelIds', 'hotels', 'hotelId', 0);
        this.checkSelected(true, 'benefitIds', 'benefit', 'rewardCatalogId', 0);
      }
    }, err => {
      console.error('Error while getting filter look up date: ', err.message);
    })
  }

  getBenefitsList(page?) {
    let headerColumns = Object.assign([], this.tableHeader);
    headerColumns.push(headerColumns.shift());
    let data = {
      filter: this.filterForm.value,
      isFilterOn: this.isFilterOn,
      pageNumber: page != null ? page : this.p,
      hotelChainId: JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId,
      value: this.searchForm.get('searchTerm').value,
      sorting: headerColumns
    }
    this.employeeService.getExchangeOfBenefitsList(data).subscribe(res => {
      if (res.error == 0) {
        this.isFiltered = this.checkGroupFilter();
        this.BenefitsList = res.responseObj.results;
        this.totalCount = res.responseObj.totalRecords;
      }
    }, err => {
      console.error('Error while fetching Employee List: ', err.message);
    })
  }

  getSelectedStr(length, type) {
    return `${length} ${type}${length !== 1 ? 's' : ''} Selected`;
  }

  selectedValue(type, data) {
    // if (type == 'hotel') {
    //   this.filterForm.get('hotelName').setValue(data && data.hotelName ? data.hotelName : null);
    //   this.filterForm.get('hotel').setValue(data && data.hotelId ? data.hotelId : null);
    // } else if (type == 'benefit') {
      this.filterForm.get('benefitName').setValue(data && data.productNameEN ? data.productNameEN : null);
      this.filterForm.get('benefit').setValue(data && data.rewardCatalogId ? data.rewardCatalogId : null);
    // }
  }

  printVochuer(benefit) {
    this.utilService.printVoucher(benefit, 'print');
  }
  

  checkSelected(isChecked: boolean, controlName, type, valueType, value) {
    let formArray = this.filterForm.controls[controlName] as FormArray;
    if (isChecked) {
      if (value == 0) {
        while (formArray.value.length !== 0) {
          formArray.removeAt(0)
        }
        formArray.push(new FormControl(0));
        this.filterLookUpDate[type].forEach(value => {
          formArray.push(new FormControl(value[valueType]));
        });
      } else {
        formArray.push(new FormControl(value));
        if (formArray.value.indexOf(0) == -1 && this.filterLookUpDate[type].length == formArray.value.length) {
          formArray.push(new FormControl(0));
        }
      }
    } else {
      if (value == 0) {
        while (formArray.value.length !== 0) {
          formArray.removeAt(0)
        }
      } else {
        let index = formArray.controls.findIndex(x => x.value == value);
        if (index > -1) {
          formArray.removeAt(index);
        }
        if (formArray.value.indexOf(0) > -1) {
          if (this.filterLookUpDate[type].length != formArray.value.length - 1) {
            let idx = formArray.controls.findIndex(x => x.value == 0);
            if (idx > -1) {
              formArray.removeAt(idx);
            }
          }
        }
      }
    }
  }

  // get getSelectedBenefits() {
  //   return this.utilService.cleanArray(this.BenefitsList.map(employee => {
  //     if (employee.checked) {
  //       this.activateAction = true;
  //       return employee.loyaltyMemberId;
  //     } else {
  //       this.activateAction = false;
  //       return null;
  //     }
  //   }))
  // }

  // selectExchanges(type) {
  //   if (type == 'all') {
  //     for (var i = 0; i < this.BenefitsList.length; i++) {
  //       this.BenefitsList[i].checked = this.allBenefitsSelected;
  //     }
  //   } else {
  //     this.allBenefitsSelected = this.BenefitsList.every(function (item: any) {
  //       return item.checked == true;
  //     })
  //   }
  //   this.selectedBenefits = this.getSelectedBenefits;
  // }

  pageChanged($event) {
    let page = $event - 1;
    this.getBenefitsList(page);
    this.allBenefitsSelected = false;
    // this.selectExchanges('all');
    this.p = $event;
  }

  checkGroupFilter() {
    if (!this.isFilterOn && !this.searchForm.get('searchTerm').value) {
      return false;
    } else {
      return true;
    }
  }

  checkFilterOn() {
    let formGroup = this.filterForm.value;
    if (!formGroup.startDate && !formGroup.endDate && !formGroup.status && !formGroup.benefit && formGroup.hotelIds && formGroup.hotelIds.indexOf(0) > -1) {
      return false;
    } else {
      return true;
    }
  }

  clearDate() {
    if (this.filterForm.get('range').value) {
      this.filterForm.get('range').setValue(null);
      this.filterForm.get('startDate').setValue(null);
      this.filterForm.get('endDate').setValue(null);
    }
  }

  openStatusModal(id?, mode?) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    let message = mode == 0 ? "Are you sure you want to deactivate this Employee(s)?" : "Are you sure you want to activate this Employee(s)?";
    let title = mode == 0 ? "Deactivate Employee" : "Activate Employee";
    let action1 = mode == 0 ? "Deactivate" : "Activate";
    let style = mode == 0 ? "inactive" : "active";
    let status = mode;
    this.statusModal.content.srcObject = {
      mode: "custom",
      type: 'member-edit',
      title: title,
      message: message,
      status,
      id: id,
      action1: action1,
      action2: 'Cancel',
      action: '',
      style: style
    }
  }

  initFilterForm() {
    let hotels = this.fb.array([]);
    let benefits = this.fb.array([]);
    this.filterForm = this.fb.group({
      status: [''],
      benefitIds: benefits,
      benefitName: [''],
      hotelIds: hotels,
      startDate: [null],
      endDate: [null],
      range: [null]

    });
    this.filterForm.controls['range'].valueChanges.debounceTime(200).subscribe(value => {
      if (!value || (value && !value.length)) {
        this.filterForm.get('startDate').setValue(null);
        this.filterForm.get('endDate').setValue(null);
      } else {
        this.filterForm.get('startDate').setValue(value[0] ? this.utilService.formatDate(value[0]) : null);
        this.filterForm.get('endDate').setValue(value[1] ? this.utilService.formatDate(value[1]) : null);
      }
    })
    this.filterForm.valueChanges.debounceTime(400).distinctUntilChanged().subscribe(value => {
      this.isFilterOn = this.checkFilterOn();
      this.pageChanged(1);
    })
  }

  initSearchForm() {
    this.searchForm = this.fb.group({
      searchTerm: ['']
    });
    this.searchForm.get('searchTerm').valueChanges.debounceTime(400).distinctUntilChanged()
      .subscribe(term => {
        this.pageChanged(1);
      })
  }

  ngOnInit() {
    this.initFilterForm();
    this.initSearchForm();
    this.getFilterLookUpDate();
    // this.getBenefitsList();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/employees/exchange-benefits/exchange-benefits.component.ts